import { render, staticRenderFns } from "./OrderView2.vue?vue&type=template&id=faf2c29e&scoped=true&"
import script from "./OrderView2.vue?vue&type=script&lang=js&"
export * from "./OrderView2.vue?vue&type=script&lang=js&"
import style0 from "./OrderView2.vue?vue&type=style&index=0&id=faf2c29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2c29e",
  null
  
)

export default component.exports